<template>
  <transition name="fade" @after-leave="$emit('close')">
    <div class="pl-tips" v-if="show" @click.stop="show = false">
      <div class="pl-tips_content" @click.stop>
        <div class="pl-tips_title">
          <i class="close-icon" @click.stop="show = false" v-if="showClose"></i>
          <span v-if="$slots.title">
            <slot name="title"></slot>
          </span>
          <span v-if="!$slots.title&&$props.title">{{title}}</span>
        </div>
        <div class="pl-tips_main" :style="mainStyle">
          <template v-if="$slots.body">
            <slot name="body"></slot>
          </template>
          <span v-if="!$slots.body&&$props.body">{{body}}</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PlTips',
  props: {
    title: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: '設置成功'
    },
    showClose: {
      type: Boolean,
      default: true
    },
    mainStyle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.show = true
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.close-icon {
  position: absolute;
  left: 2vw;
  top: 50%;
  margin: 3px;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  background: transparent;
  transform: translate3d(0, -50%, 0);
  transform: translate(0, -50%)\9;
  &:after,
  &:before {
    position: absolute;
    top: -3px;
    left: 11px;
    width: 1.5px;
    content: " ";
    height: 25px;
    background: #9c9c9c;
    transform: rotate(45deg);
  }
  &:before {
    transform: rotate(-45deg);
  }
}

.pl-tips {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  position: fixed;
  background: rgba($color: #000000, $alpha: 0.8);
  &_content {
    top: 50%;
    left: 50%;
    width: 274px;
    height: 271px;
    position: absolute;
    border-radius: 5px;
    background: #f4f4f4;
    transform: translate3d(-50%, -50%, 0);
    transform: translate(-50%, -50%)\9;
  }
  &_title {
    height: 46px;
    line-height: 46px;
    position: relative;
    text-align: center;
    border-bottom: 1px solid #e1e1e1;
  }
  &_main {
    display: flex;
    display: block\9;
    color: #333;
    font-size: 17px;
    align-items: center;
    justify-content: center;
    height: calc(100% - 47px);
  }
}
@media screen and (orientation: landscape) {
  .pl-tips_content {
    width: 275px;
    height: 183px;
  }
}
</style>
